'use strict';

angular.module('mean.projects').factory('tradeOptionsService', ['$filter', '_', 'toaster', 'taskTotalsService', '$q',
    function($filter, _, toaster, taskTotalsService, $q) {

        var stripId = function(source) {
            for(var key in source) {
                if(key === '_id') {
                    delete source[key];
                }

                if (angular.isObject(source[key])){          
                  stripId(source[key]); 
                } 
            }
        };

        function findAndReplace(object, value, replacevalue) {
            for (var x in object) {
                if (object.hasOwnProperty(x)) {
                    if (typeof object[x] == 'object') {
                    findAndReplace(object[x], value, replacevalue);
                    }
                    if (object[x] == value) { 
                    object["name"] = replacevalue;
                    // break; // uncomment to stop after first replacement
                    }
                }
            }
        }

        var resetOption = function(item) {
            item.has_options = false;
            item.is_option = false
            item.number = '';
            return item;
        };

        // pass in a subtask list and it will return true
        // if there is an option in the list, else false.
        var bidHasOptions = function(list) {
            var inlist = $filter('filter')(list, {
                'is_option': true }, true);

            if(inlist.length > 0) {
                return true;
            }

            return false;
        };

        var removeTaskOption = function(my_bid, current_option, item) {
            if(!item.task || !item.trade) {
                toaster.pop('warning', 'Bid Item Error', 
                    'The current bid does not have needed information');

                if(!item.name) {
                    for(var i=0; i<my_bid.bid.length; i++) {
                        for(var j=0; j<my_bid.bid[i].subtasks.length; j++) {
                            if(my_bid.bid[i].subtasks[j]._id === item._id) {
                                my_bid.bid[i].subtasks.splice(j, 1);
                            }
                        }
                        if(!bidHasOptions(my_bid.bid[i].subtasks)) {
                            my_bid.bid[i].has_options = false;
                        }
                    }
                }
                return;
            }

            var bids = $filter('filter')(my_bid.bid, {
                'task': item.task, 'trade': item.trade }, true);
            // now lets filter out plans we're concerned with
            bids = _.filter(bids, function(item) { 
                return current_option.plans.indexOf(item.plan_code) !== -1 });

            var task = $filter('filter')(my_bid.task_list, {
                'task': item.task, 'trade': item.trade }, true);

            if(task.length !== 1) {
                toaster.pop('error', 'Problem Getting Task',
                    'Could not get the task for option removal.');
                return;
            }
            // I'm going to have to remove the item from the 
            // my_bid.bid.subtasks arrays.  I will also have to update
            // the item.option_subtask_id so it can be reset.
            // Then I have to adjust all subtask._id's greater than
            // item._id.  Basically decrement each.  After I decrement
            // and the array looks good, I will have to take one final
            // pass and look at all the item.option_subtask_id's. If
            // I come across one that is greater than item._id, then
            // I need to decrement it by one.
            // After I've done all this fancy stuff for the bids, I
            // will have to go through the my_bid.task_list and remove
            // the associated subtask entry for item.  I will also
            // have to decrement the subtask._id by one for all subtasks
            // after the associated item.
            var reset = false;
            _.each(bids, function(bid) {
                var original = bid.subtasks[item.option_subtask_id];
                var override_idx = item._id;

                resetOption(original);
                bid.subtasks.splice(override_idx, 1);

                _.each(bid.subtasks, function(sub) {
                    if(sub) {
                        sub._id = i;
                    }
                });

                _.each(bid.subtasks, function(sub) {
                    if(sub.option_subtask_id > item._id) {
                        sub.option_subtask_id -= 1;
                    }
                });

                if(!bidHasOptions(bid.subtasks)) {
                    bid.has_options = false;
                }
            });

            // The task.subtask index matches the item so splice first
            task[0].subtasks.splice(item._id, 1);

            // Now decrement all following the item
            for(var i=item._id; i<task[0].subtasks.length; i++) {
                if(task[0].subtasks[i]) {
                    task[0].subtasks[i]._id = i;
                }
            }
        };

        var filterUniqueTaskName = function(list) {
            return $filter('unique')(list, 'name');
        };

        var filterTrade = function(list, my_trade) {
            var new_list = [];

            for(var i=0; i<list.length; i++) {
                if(list[i].trades.indexOf(my_trade) !== -1) {
                    new_list.push(list[i]);
                }
            }

            return new_list;
        };

        //get bid options from the bid list that match
        //the option number and is_option
        //this function will build a full bid task of
        //all the subtask options it finds.
        var getBidOptions = function(bid_list, option_obj) {
            var bids = [];
            var items = [];

            bids = $filter('filter')(bid_list, {
                'has_options': true }, true);

            for(var i=0; i<bids.length; i++) {
                items.push(angular.copy(bids[i]));
                items[items.length-1].subtasks = [];
                var subs = $filter('filter')(bids[i].subtasks, {
                    'number': option_obj.number,
                    'is_option': true }, true);

                for(var j=0; j<subs.length; j++) {
                    items[i].subtasks.push(subs[j]);
                }

            }

            return items;
        };

        //this function will do a deep copy/merge of
        //bid data with task data and return an array
        //of the combined data.
        var mergeBidTasks = function(bid_list, task_list) {
            var items = [];

            for(var i=0; i<bid_list.length; i++) {
                var index = bid_list[i].task_id - 1;
                var saved_id = angular.copy(bid_list[i]._id);

                var object = angular.merge({}, 
                    bid_list[i], task_list[index]);

                object._id = saved_id;
                items.push(object);
            }
            return items
        }

        var getBidSubtasks = function(my_bid, bid_list) {
            var items = [];
            var unique_plan = bid_list[0].plan;

            var bids = $filter('filter')(bid_list, {
                'plan': unique_plan }, true);
            
            for(var i=0; i<bids.length; i++) {
                var task = $filter('filter')(my_bid.task_list, {
                    'task': bids[i].task, 
                    'trade': bids[i].trade}, true);
                if(task.length !== 1) {
                    alert('Big problems');
                }

                for(var j=0; j<bids[i].subtasks.length; j++) {
                    if(!bids[i].subtasks[j].is_option) {
                        items.push(task[0].subtasks[j]);
                    }
                }
            }
            return items;
        }

        //this function will get the tasks associated
        //with the passed in option_obj.bids and fill
        //in a new array in option_obj.tasks
        var getOptionTasks = function(option_obj, task_list) {
            var task_array = $filter('unique')(option_obj.bids, 'task');
            option_obj.tasks = [];

            for(var i=0; i<task_array.length; i++) {
                var inlist = $filter('filter')(task_list, {
                    'task': task_array[i].task, 
                    'trade': task_array[i].trade }, true);

                if(inlist.length === 1) {
                    option_obj.tasks.push(inlist[0]);
                } else {
                    alert('we  got problems');
                }
            }
        };

        return {
            stripId: stripId,
            //addSubtaskOption: addSubtaskOption,
            removeTaskOption: removeTaskOption,
            filterUniqueTaskName: filterUniqueTaskName,
            filterTrade: filterTrade,
            getBidOptions: getBidOptions,
            mergeBidTasks: mergeBidTasks,
            getBidSubtasks: getBidSubtasks,
            getOptionTasks: getOptionTasks
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/trades/public/services/trade-options-service.js